"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = void 0 && (void 0).__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarList = exports.SidebarItem = void 0;
var react_1 = __importStar(require("react"));
var SidebarItem_1 = __importDefault(require("./SidebarItem"));
exports.SidebarItem = SidebarItem_1["default"];
var SidebarList_1 = __importDefault(require("./SidebarList"));
exports.SidebarList = SidebarList_1["default"];
var od_icon_1 = __importDefault(require("@tencent/od-icon"));
var odc_divider_1 = __importDefault(require("@tencent/odc-divider"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
function Sidebar(_a) {
  var data = _a.data,
    value = _a.value,
    onChange = _a.onChange,
    HeaderComponent = _a.HeaderComponent,
    FooterComponent = _a.FooterComponent,
    LinkComponent = _a.LinkComponent,
    _b = _a.zIndex,
    zIndex = _b === void 0 ? 100 : _b,
    _c = _a.needCollapse,
    needCollapse = _c === void 0 ? true : _c,
    collapse = _a.collapse,
    onCollapse = _a.onCollapse;
  var _d = __read((0, react_1.useState)(!collapse), 2),
    open = _d[0],
    setOpen = _d[1];
  var _e = __read((0, react_1.useState)(false), 2),
    hoverOpen = _e[0],
    setHoverOpen = _e[1];
  var hasOpen = (0, react_1.useMemo)(function () {
    return open || hoverOpen;
  }, [open, hoverOpen]);
  var handlerHoverOpen = (0, react_1.useCallback)(function (op) {
    if (open) return;
    setHoverOpen(op);
  }, [open]);
  (0, react_1.useEffect)(function () {
    if (needCollapse) {
      collapse !== undefined && setOpen(!collapse);
    }
  }, [collapse, needCollapse]);
  var sidebarContentRef = (0, react_1.useRef)(null);
  var sidebarMenusRef = (0, react_1.useRef)(null);
  (0, react_1.useEffect)(function () {
    if (!sidebarContentRef.current) return;
    var callback = function callback(items) {
      items.forEach(function (item) {
        if (!sidebarMenusRef.current) return;
        sidebarMenusRef.current.style.maxHeight = "".concat(item.contentRect.height, "px");
      });
    };
    var observer = new ResizeObserver(callback);
    observer.observe(sidebarContentRef.current);
    return function () {
      return observer.disconnect();
    };
  }, []);
  return react_1["default"].createElement("div", {
    className: "odc-sidebar-content ".concat(open ? 'open' : 'no-open'),
    style: {
      zIndex: zIndex
    },
    ref: sidebarContentRef
  }, react_1["default"].createElement("div", {
    className: "odc-sidebar ".concat(hoverOpen ? 'hover-open' : ''),
    onMouseEnter: function onMouseEnter() {
      return handlerHoverOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return handlerHoverOpen(false);
    },
    ref: sidebarMenusRef
  }, HeaderComponent === null || HeaderComponent === void 0 ? void 0 : HeaderComponent(open, hoverOpen), react_1["default"].createElement("div", {
    className: "odc-sidebar-top"
  }, data === null || data === void 0 ? void 0 : data.map(function (item, idx) {
    return item.data && item.data.length > 0 ? react_1["default"].createElement(SidebarList_1["default"], __assign({
      open: hasOpen,
      value: value
    }, item, {
      key: idx,
      onChange: onChange,
      LinkComponent: LinkComponent
    })) : react_1["default"].createElement(SidebarItem_1["default"], __assign({
      active: item.key === value
    }, item, {
      key: idx,
      LinkComponent: LinkComponent,
      onClick: function onClick() {
        !item.disable && (onChange === null || onChange === void 0 ? void 0 : onChange(item));
      }
    }));
  })), react_1["default"].createElement("div", {
    className: "flex justify-center ".concat(hasOpen ? 'px-16' : ''),
    style: {
      marginBottom: -4
    }
  }, react_1["default"].createElement(odc_divider_1["default"], {
    type: "horizontal",
    height: 1,
    width: hasOpen ? '100%' : '16px',
    color: "rgba(73, 90, 122, 0.16)",
    gap: 12
  })), react_1["default"].createElement("div", {
    className: "odc-sidebar-bottom flex flex-column"
  }, FooterComponent === null || FooterComponent === void 0 ? void 0 : FooterComponent(open, hoverOpen), needCollapse && react_1["default"].createElement(SidebarItem_1["default"], {
    type: "ability",
    label: open ? '收起' : '展开',
    onClick: function onClick() {
      if (onCollapse && collapse !== undefined) return onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!collapse);
      onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!open);
      setOpen(function (i) {
        return !i;
      });
    },
    icon: react_1["default"].createElement(od_icon_1["default"], {
      className: "odc-sidebar-item-icon",
      name: "unfold-outlined",
      style: {
        transform: open ? 'scaleX(-1)' : 'scaleX(1)'
      }
    })
  }))));
}
(0, spaui_utils_1.setComponentMark)(Sidebar, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Sidebar));